module.exports = "<Card body>This is some text within a card body.</Card>;\n"